import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=0cb8a803&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=0cb8a803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8a803",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb8a803')) {
      api.createRecord('0cb8a803', component.options)
    } else {
      api.reload('0cb8a803', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=0cb8a803&scoped=true&", function () {
      api.rerender('0cb8a803', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invitation/activity/components/addDynamic.vue"
export default component.exports